"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = exports.SettingsButton = exports.ModalContent = exports.FormWrapper = exports.FlexWrapper = exports.DenyButton = exports.CancelButtonX = exports.ButtonsWrapper = exports.BlueButton = exports.BannerWrapper = exports.BannerTitle = exports.BannerDescription = exports.BannerActions = exports.ActionButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Button_style_1 = require("../../atoms/Button/Button.style");
const ModalContent = styled_components_1.default.div `
  background-color: ${colors_1.white};
  opacity: 1;
  border-radius: 8px;
  position: relative;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;
exports.ModalContent = ModalContent;
const ButtonsWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding-top: 0.625rem;
`;
exports.ButtonsWrapper = ButtonsWrapper;
const FlexWrapper = styled_components_1.default.div `
  display: flex;
  padding-bottom: 0.625rem;
`;
exports.FlexWrapper = FlexWrapper;
const ActionButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: ${colors_1.blue};
  color: ${colors_1.white};
  font-weight: 100;
  border: none;
  @media ${media_1.media.desktop} {
    height: 30px;
    font-size: 1rem;
    img {
      width: 1rem;
      height: 1rem;
    }
  }
`;
exports.ActionButton = ActionButton;
const CancelButtonX = (0, styled_components_1.default)(Button_style_1.Button) `
  color: ${colors_1.gray400};
  font-weight: 100;
  border: none;

  @media ${media_1.media.desktop} {
    display: flex;
    align-items: center;
    height: auto;
    padding: 0;
    cursor: pointer;
    img {
      width: 1rem;
      height: 1rem;
    }
  }
`;
exports.CancelButtonX = CancelButtonX;
const TextInput = styled_components_1.default.input `
  width: 100%;
  padding: 0.625rem;
  border: 1px solid ${colors_1.gray100};
  border-radius: 4px;
  margin-bottom: 0.625rem;
  outline: none;
  font-size: 1.6rem;
`;
exports.TextInput = TextInput;
const BlueButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: ${colors_1.blue};
  color: ${colors_1.white};
  font-weight: 600;
  border: none;
  width: fit-content;
  font-size: 1.1rem;
  height: 0.8rem;
  text-transform: uppercase;
`;
exports.BlueButton = BlueButton;
const FormWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
exports.FormWrapper = FormWrapper;
const BannerWrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  background: ${colors_1.white};
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
  padding: 2rem 2.5rem;
  z-index: 1000;
  min-width: 340px;
  max-width: 95vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
exports.BannerWrapper = BannerWrapper;
const BannerTitle = styled_components_1.default.h2 `
  color: ${colors_1.acBlue};
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;
exports.BannerTitle = BannerTitle;
const BannerDescription = styled_components_1.default.p `
  color: #222;
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;
exports.BannerDescription = BannerDescription;
const BannerActions = styled_components_1.default.div `
  display: flex;
  gap: 1rem;
  width: 100%;
`;
exports.BannerActions = BannerActions;
const DenyButton = (0, styled_components_1.default)(BlueButton) `
  background: ${colors_1.gray400};
  color: ${colors_1.white};
`;
exports.DenyButton = DenyButton;
const SettingsButton = (0, styled_components_1.default)(BlueButton) `
  background: transparent;
  color: ${colors_1.acBlue};
  border: 1.5px solid ${colors_1.acBlue};
`;
exports.SettingsButton = SettingsButton;
